import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import {
  applicantExamTimeLeftAction,
  challengeTimeLeftAction,
  applicantExamSubmitAction,
  applicantTickAction,
  applicantNotificationAddAction,
} from "../../../../../actions";
import { RootState } from "../../../../../reducers";
import { TimerHeadquarter } from "./TimerHeadquarter";

const mapStateToProps = (state: RootState) => ({
  tutorial: Boolean(window && window.location.pathname.startsWith("/tutorial")),
  exam: state.applicant.exam,
  timer: state.applicantTimer,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  tick: () => {
    dispatch(applicantTickAction.request());
  },
  getExamTimeLeft: () => {
    dispatch(applicantExamTimeLeftAction.request());
  },
  getChallengeTimeLeft: (challengeId: number, resultId: number) => {
    dispatch(challengeTimeLeftAction.request(challengeId, resultId));
  },
  submitExam: () => {
    dispatch(applicantExamSubmitAction.request());
  },
  addNotification: (item: React.ReactElement) => {
    dispatch(applicantNotificationAddAction.request(item));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerHeadquarter);
